import {useEffect, useState, useRef} from 'react'
import { useNavigate } from 'react-router-dom';
import PageApp from '../../../Page';
import ModalEdit from './Edit'
import { HomeOutlined, UnorderedListOutlined, ClockCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space, Tag} from 'antd';
import {getAll, drop} from '../../../../apis/RutasApi';
import _ from 'lodash'

const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Catálogos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Rutas</span>
      </>
    ),
}];

const RutasPage = () => {
    let navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [objectSelected, setObjectSelected] = useState(null);
    const [loading, setLoading] = useState(true);
    
    const columns = [
      {
        title: 'Ruta',
        dataIndex: 'ruta',
        key: 'ruta',
      },
      {
        title: 'Descripción',
        dataIndex: 'descripcion',
        key: 'descripcion',
      },
      {
        title: 'Estado',
        dataIndex: 'estado',
        key: 'estado',
      },
      {
        title: 'Ciudad',
        dataIndex: 'ciudad',
        key: 'ciudad',
      },
      {
        title: 'Codigo Postal',
        dataIndex: 'codigo_postal',
        key: 'codigo_postal',
      },
      {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        render: (item, object)=> {
          return <Space>
          <Button type='primary' size='small' onClick={()=>{
              openDetails(object);
          }}>Editar</Button>
          <Button type='primary' size='small' danger onClick={()=>{
              deleteConfirm(object);
          }}>Eliminar</Button>
        </Space>
        }
      }
    ];

    const openDetails = async (object)=>{
      setOpenEdit(true);
      setObjectSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas eliminar la ruta?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await drop(id);
        if(response.ok){
            message.success('¡La Ruta ha sido eliminada!');
        }
        await refreshData();
    }

    const btnClick = ()=>{
      setOpenEdit(true);
      setObjectSelected(null);
    }

    const onHandlerFinish = async (refresh) => {
      setOpenEdit(false);
      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAll();
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }

      setLoading(false);
    }

    const effectRan = useRef(false);
    useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    return <PageApp routes={routes}
        title={'Rutas'} 
        cardTitle='Lista de rutas'
        extraCard={[
          <Button type="primary" onClick={btnClick}>
            Agregar Ruta
          </Button>
        ]}>
      {
          loading ? (
            <p>Loading...</p>
          ) : <>
            {
              items.length == 0 ? <Empty />:
              <Table dataSource={items} columns={columns} />
            }
          </>
      }
      {
        (openEdit && objectSelected && objectSelected.id > 0) &&
        <ModalEdit title={"Editar Ruta"} id={objectSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !objectSelected) &&
        <ModalEdit title={"Crear Ruta"} open={openEdit} finish={onHandlerFinish}/>
      }
    </PageApp>
}   

export default RutasPage;
